import React from 'react';
import PropTypes from 'prop-types';

// Components
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import AddAVirtualEventButton from 'components/manage/common/AddAVirtualEventButton';
import EditPageSortableList from '../EditPageSortableList';

// Styles
import './EditPageAddEntity.less';

const EditPageAddEntity = ({
  children,
  entitiesListTitle,
  entityName,
  onAddButton,
  onAddText,
  onAdd,
  onEdit,
  onDelete,
  orderedIds,
  entityDetail,
  entities,
  pageType,
  isVirtualEventTourDisabled,
}) => {
  const entityType = pageType && pageType.toLowerCase();
  const showVirtualEventButton = isVirtualEventTourDisabled;

  return (
    <section className={`edit-page__add-entity-section add-entity-section--${entityType}`}>
      <div className="entities-list-section">
        <h4 className="entities-list-title">{entitiesListTitle || `Your ${entityName}s`}</h4>
        <div className="entities-list-wrap">
          <>
            {entityDetail ? (
              <EditPageSortableList
                entityType={entityType}
                orderedIds={orderedIds}
                entities={entities}
                onEdit={onEdit}
                onDelete={onDelete}
                entityDetail={entityDetail}
                useDragHandle
                lockAxis="y"
              />
            ) : (
              children
            )}
          </>
        </div>
      </div>
      <div className="add-entity-btns-section">
        {onAddButton || (
          <ButtonV2 type="button" onClick={onAdd}>
            {onAddText || `Add A ${entityName}`}
          </ButtonV2>
        )}
        {showVirtualEventButton && (
          <AddAVirtualEventButton
            className="add-entity-btns-section__virtual"
            variant="secondary"
          />
        )}
      </div>
    </section>
  );
};

EditPageAddEntity.propTypes = {
  children: PropTypes.node,
  entitiesListTitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  entityName: PropTypes.string,
  onAdd: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onAddText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  onAddButton: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  entityDetail: PropTypes.func,
  entities: PropTypes.shape({}),
  pageType: PropTypes.string,
  isVirtualEventTourDisabled: PropTypes.bool,
};

export default EditPageAddEntity;
